import { z } from "zod";

// Own module rather than appended to reporting-period.ts — both the periods
// feature (per-client) and the insights feature (industry rollup, later)
// consume this shape.
export const EmergencyMapPointSchema = z.object({
  addressRaw: z.string(),
  lat: z.number(),
  lng: z.number(),
  state: z.string().nullable(),
  count: z.number(),
  teamNames: z.array(z.string()),
});

export const EmergencyMapResponseSchema = z.object({
  points: z.array(EmergencyMapPointSchema),
  totalEvents: z.number(),
  unmappedEvents: z.number(),
  pendingGeocodeCount: z.number(),
});

export type EmergencyMapPoint = z.infer<typeof EmergencyMapPointSchema>;
export type EmergencyMapResponse = z.infer<typeof EmergencyMapResponseSchema>;
